const API_BASE = "/api";

export class ApiError extends Error {
  constructor(message, options = {}) {
    super(message);
    this.name = "ApiError";
    this.status = options.status || 0;
    this.code = options.code || "REQUEST_FAILED";
    this.details = options.details;
  }
}

async function request(path, options = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      credentials: "same-origin",
      headers: options.body ? { "Content-Type": "application/json", ...(options.headers || {}) } : options.headers,
      ...options,
      body: options.body && typeof options.body !== "string" ? JSON.stringify(options.body) : options.body,
    });
  } catch (error) {
    throw new ApiError("无法连接系统服务，请确认服务端正在运行", { code: "NETWORK_UNAVAILABLE", details: error });
  }

  const type = response.headers.get("content-type") || "";
  const payload = type.includes("application/json") ? await response.json().catch(() => ({})) : await response.text();
  if (!response.ok) {
    throw new ApiError(payload?.message || `请求失败（${response.status}）`, {
      status: response.status,
      code: payload?.code || "REQUEST_FAILED",
      details: payload,
    });
  }
  return payload;
}

export const api = {
  health: () => request("/health"),
  publicSettings: () => request("/public/settings"),
  publicContent: () => request("/public/content"),
  recordVisit: () => request("/access/visit", { method: "POST" }),
  refreshChallenge: () => request("/access/challenge", { method: "POST" }),
  verifyChallenge: (challengeId, answer) => request("/access/verify", { method: "POST", body: { challengeId, answer } }),
  submitLead: (lead) => request("/leads", { method: "POST", body: lead }),
  subscribe: (email) => request("/subscribers", { method: "POST", body: { email } }),
  session: () => request("/auth/session"),
  login: (username, password) => request("/auth/login", { method: "POST", body: { username, password } }),
  logout: () => request("/auth/logout", { method: "POST" }),
  adminState: () => request("/admin/state"),
  saveSettings: (settings) => request("/admin/settings", { method: "PUT", body: settings }),
  updateLead: (id, changes) => request(`/admin/leads/${encodeURIComponent(id)}`, { method: "PATCH", body: changes }),
  deleteLead: (id) => request(`/admin/leads/${encodeURIComponent(id)}`, { method: "DELETE" }),
  deleteSubscriber: (id) => request(`/admin/subscribers/${encodeURIComponent(id)}`, { method: "DELETE" }),
  updateProject: (id, changes) => request(`/admin/projects/${encodeURIComponent(id)}`, { method: "PATCH", body: changes }),
  markNotificationsRead: () => request("/admin/notifications/read", { method: "POST" }),
  createContent: (section, item) => request(`/admin/content/${encodeURIComponent(section)}`, { method: "POST", body: item }),
  updateContent: (section, id, item) => request(`/admin/content/${encodeURIComponent(section)}/${encodeURIComponent(id)}`, { method: "PUT", body: item }),
  deleteContent: (section, id) => request(`/admin/content/${encodeURIComponent(section)}/${encodeURIComponent(id)}`, { method: "DELETE" }),
};

export function downloadAdminBackup() {
  const anchor = document.createElement("a");
  anchor.href = `${API_BASE}/admin/export`;
  anchor.download = "hnzw-backup.json";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
